import PropTypes from 'prop-types';
import { useDroppable } from '@dnd-kit/core';

/**
 * Wrapper component for dnd-kit's useDroppable to provide a similar API to react-beautiful-dnd's Droppable
 * @component
 */
const Droppable = ({ children, droppableId, isDropDisabled = false, type }) => {
	const { isOver, setNodeRef } = useDroppable({
		id: droppableId,
		disabled: isDropDisabled,
		data: {
			type,
		},
	});

	// Create a snapshot object similar to react-beautiful-dnd
	const snapshot = {
		isDraggingOver: isOver,
		draggingOverWith: null, // dnd-kit doesn't provide this directly
		draggingFromThisWith: null, // dnd-kit doesn't provide this directly
	};

	// Create a provided object similar to react-beautiful-dnd
	const provided = {
		innerRef: setNodeRef,
		droppableProps: {
			'data-droppable-id': droppableId,
		},
		placeholder: null, // dnd-kit handles placeholders differently
	};

	return children(provided, snapshot);
};

Droppable.propTypes = {
	children: PropTypes.func.isRequired,
	droppableId: PropTypes.string.isRequired,
	isDropDisabled: PropTypes.bool,
	type: PropTypes.string,
};

export default Droppable;
